import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { App } from "./App.tsx"
import { restoreSession } from "./features/auth/session.ts"
import "./styles.css"

restoreSession()

// A tab opened before a release asks for the old release's chunks (gone after the
// swap): load the new release once instead of failing (at most once a minute, so
// a chunk that's really missing doesn't loop).
window.addEventListener("vite:preloadError", (event) => {
  const key = "trader.reloadedForRelease"
  try {
    const last = Number(sessionStorage.getItem(key) ?? 0)
    if (Date.now() - last < 60_000) return
    sessionStorage.setItem(key, String(Date.now()))
  } catch {
    return
  }
  event.preventDefault()
  window.location.reload()
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
